import React, { Component } from "react";
import { Route, Routes } from 'react-router-dom';
import MPTPageContent from "./component/MPTPageContent/MPTPageContent";
import MptsSelector from './component/MptSelector/MptsSelector';
import { PageNotFound } from './component/PageNotFound';
import { dataAcid, dataGenesis, dataGlacier, dataMain, dataNightmare, dataOnyx, dataPoisoned, dataRoyale, dataSekansAcid, dataSekansGlacier, dataSekansPrototype, dataSekansRoyale, dataSekansVolcano, dataSunset, dataTemple, dataVolcano } from "./data";
import { goToMpt } from "./logic/pathRelated";


class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      
    }
    this.navBarRef = React.createRef()
    this.setKeyboardKeys()
  }

  setKeyboardKeys() {
    this.keyboardKeys = {
      keyO: {
        pressed: false
      },
      Backspace: {
        pressed: false
      },
      Digit0: {
        pressed: false
      },
      Digit1: {
        pressed: false
      },
      Digit2: {
        pressed: false
      },
      Digit3: {
        pressed: false
      },
      Digit4: {
        pressed: false
      },
      Digit5: {
        pressed: false
      },
      Digit6: {
        pressed: false
      },
      Digit7: {
        pressed: false
      },
      Digit8: {
        pressed: false
      },
      Digit9: {
        pressed: false
      },
      ShiftLeft: {
        pressed: false
      },
    }
  }

  componentDidMount() {
    this.keyCodeListener()
  }

  keyCodeListener() {
    document.addEventListener('keydown', event => {
      // console.log(event.code)
      this.navBarKeysDown(event.code)
      this.linksToMptsKeysDown(event.code)

      switch(this.state.activeModel) {
        case "xopowo":
          this.xopowoKeysCode(event.code)
          break

        case "sekans":
          this.sekansKeysCode(event.code)
          break

        default: break
      }

      this.checkKeysCombination()
    })

    document.addEventListener('keyup', event => {
      this.navBarKeysUp(event.code)
      this.linksToMptsKeysUp(event.code)
    })
  }

  navBarKeysDown(code) {
    switch(code) {
      case "Backspace":
        this.keyboardKeys.Backspace.pressed = true
        break
      
      case "KeyO":
        this.keyboardKeys.keyO.pressed = true
        break

      default: break
    }
  }

  navBarKeysUp(code) {
    switch(code) {
      case "Backspace":
        this.keyboardKeys.Backspace.pressed = false
        break
      
      case "KeyO":
        this.keyboardKeys.keyO.pressed = false
        break
        
      default: break
    }
  }

  linksToMptsKeysDown(code) {
    switch(code) {    
      case "Digit0":
        this.keyboardKeys.Digit0.pressed = true
        break
      
      case "Digit1":
        this.keyboardKeys.Digit1.pressed = true
        break
      
      case "Digit2":
        this.keyboardKeys.Digit2.pressed = true
        break
      
      case "Digit3":
        this.keyboardKeys.Digit3.pressed = true
        break
      
      case "Digit4":
        this.keyboardKeys.Digit4.pressed = true
        break
      
      case "Digit5":
        this.keyboardKeys.Digit5.pressed = true
        break
      
      case "Digit6":
        this.keyboardKeys.Digit6.pressed = true
        break
      
      case "Digit7":
        this.keyboardKeys.Digit7.pressed = true
        break
      
      case "Digit8":
        this.keyboardKeys.Digit8.pressed = true
        break
      
      case "Digit9":
        this.keyboardKeys.Digit9.pressed = true
        break
      
      case "ShiftLeft":
        this.keyboardKeys.ShiftLeft.pressed = true
        break
      
      default: break
    }
  }

  linksToMptsKeysUp(code) {
    switch(code) {
      case "Digit0":
        this.keyboardKeys.Digit0.pressed = false
        break
      
      case "Digit1":
        this.keyboardKeys.Digit1.pressed = false
        break
      
      case "Digit2":
        this.keyboardKeys.Digit2.pressed = false
        break
      
      case "Digit3":
        this.keyboardKeys.Digit3.pressed = false
        break
      
      case "Digit4":
        this.keyboardKeys.Digit4.pressed = false
        break
      
      case "Digit5":
        this.keyboardKeys.Digit5.pressed = false
        break
      
      case "Digit6":
        this.keyboardKeys.Digit6.pressed = false
        break
      
      case "Digit7":
        this.keyboardKeys.Digit7.pressed = false
        break
      
      case "Digit8":
        this.keyboardKeys.Digit8.pressed = false
        break
      
      case "Digit9":
        this.keyboardKeys.Digit9.pressed = false
        break
      
      case "ShiftLeft":
        this.keyboardKeys.ShiftLeft.pressed = false
        break
        
      default: break
    }
  }

  checkKeysCombination() {
    if (this.keyboardKeys.ShiftLeft.pressed && this.keyboardKeys.Digit0.pressed) console.log("ici")
    if (this.keyboardKeys.keyO.pressed) {
      this.keyboardKeys.keyO.pressed = false
      window.open("https://opensea.io/collection/musicproductiontoken", "blank")
      return
    }

    if (this.keyboardKeys.Backspace.pressed) {
      goToMpt("/")
      return
    }

    if (this.keyboardKeys.Digit0.pressed && this.keyboardKeys.ShiftLeft.pressed) {
      goToMpt("/sekansprototype")
      return
    }

    if (this.keyboardKeys.Digit1.pressed && this.keyboardKeys.ShiftLeft.pressed) {
      goToMpt("/sekansglacier")
      return
    }

    if (this.keyboardKeys.Digit2.pressed && this.keyboardKeys.ShiftLeft.pressed) {
      goToMpt("/sekansacid")
      return
    }

    if (this.keyboardKeys.Digit3.pressed && this.keyboardKeys.ShiftLeft.pressed) {
      goToMpt("/sekansvolcano")
      return
    }

    if (this.keyboardKeys.Digit4.pressed && this.keyboardKeys.ShiftLeft.pressed) {
      goToMpt("/sekansroyale")
      return
    }

    if (this.keyboardKeys.Digit0.pressed) {
      goToMpt("/x0p0w0genesis")
      return
    }
    
    if (this.keyboardKeys.Digit1.pressed) {
      goToMpt("/x0p0w0onyx")
      return
    }

    if (this.keyboardKeys.Digit2.pressed) {
      goToMpt("/x0p0w0temple")
      return
    }

    if (this.keyboardKeys.Digit3.pressed) {
      goToMpt("/x0p0w0nightmare")
      return
    }

    if (this.keyboardKeys.Digit4.pressed) {
      goToMpt("/x0p0w0volcano")
      return
    }

    if (this.keyboardKeys.Digit5.pressed) {
      goToMpt("/x0p0w0glacier")
      return
    }
    
    if (this.keyboardKeys.Digit6.pressed) {
      goToMpt("/x0p0w0royale")
      return
    }
    
    if (this.keyboardKeys.Digit7.pressed) {
      goToMpt("/x0p0w0acid")
      return
    }
    
    if (this.keyboardKeys.Digit8.pressed) {
      goToMpt("/x0p0w0poisoned")
      return
    }
    
    if (this.keyboardKeys.Digit9.pressed) {
      goToMpt("/x0p0w0sunset")
      return
    }

      // case "KeyI":
      //   goToMpt("/sequenceur")
      //   break

      // case "KeyP": 
      //   goToMpt("/recorder")
      //   break
  }
  
  render() {
    return (
      <React.Fragment>
          <Routes>
            <Route exact path="/" element={<MptsSelector />} />
            <Route exact path="/x0p0w0genesis" element={<MPTPageContent data={dataGenesis} dataMain={dataMain} />} />
            <Route exact path="/x0p0w0onyx" element={<MPTPageContent data={dataOnyx} dataMain={dataMain} />} />
            <Route exact path="/x0p0w0glacier" element={<MPTPageContent data={dataGlacier} dataMain={dataMain} />} />
            <Route exact path="/x0p0w0nightmare" element={<MPTPageContent data={dataNightmare} dataMain={dataMain} />} />
            <Route exact path="/x0p0w0sunset" element={<MPTPageContent data={dataSunset} dataMain={dataMain} />} />
            <Route exact path="/x0p0w0temple" element={<MPTPageContent data={dataTemple} dataMain={dataMain} />} />
            <Route exact path="/x0p0w0acid" element={<MPTPageContent data={dataAcid} dataMain={dataMain} />} />
            <Route exact path="/x0p0w0poisoned" element={<MPTPageContent data={dataPoisoned} dataMain={dataMain} />} />
            <Route exact path="/x0p0w0volcano" element={<MPTPageContent data={dataVolcano} dataMain={dataMain} />} />
            <Route exact path="/x0p0w0royale" element={<MPTPageContent data={dataRoyale} dataMain={dataMain} />} />
            <Route exact path="/sekansprototype" element={<MPTPageContent data={dataSekansPrototype} dataMain={dataMain} />} />
            <Route exact path="/sekansglacier" element={<MPTPageContent data={dataSekansGlacier} dataMain={dataMain} />} />
            <Route exact path="/sekansacid" element={<MPTPageContent data={dataSekansAcid} dataMain={dataMain} />} />
            <Route exact path="/sekansvolcano" element={<MPTPageContent data={dataSekansVolcano} dataMain={dataMain} />} />
            <Route exact path="/sekansroyale" element={<MPTPageContent data={dataSekansRoyale} dataMain={dataMain} />} />
            {/* 
            <Route exact path="/sequenceur" element={<Sequenceur />} />
            <Route exact path="/recorder" element={<Recorder />} />
            <Route exact path="/piano" element={<PianoLogic data={dataPiano} />} />
            <Route exact path="/mixer" element={<Mixer />} />
            <Route exact path="/mptpagecontent" element={<MPTPageContent data={dataSekansPrototype} />} />
            <Route exact path="/arpeggioprototype" element={<MPTPageContent data={dataArpeggioPrototype} />} /> 
            */}
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        
      </React.Fragment>
    )
  }
}

export default App